import type { Cliente } from './cliente.types';
import type { TipologiaScadenza } from './tipologia.types';
import type { User } from './user.types';

export const StatoScadenza = {
  ATTIVA: 'attiva',
  IN_SCADENZA: 'in_scadenza',
  SCADUTA: 'scaduta',
  COMPLETATA: 'completata',
  ANNULLATA: 'annullata'
} as const;

export type StatoScadenza = typeof StatoScadenza[keyof typeof StatoScadenza];

export interface Scadenza {
  id: string;
  clienteId: string;
  cliente?: Cliente;
  tipologiaId: string;
  tipologia?: TipologiaScadenza;
  dataScadenza: string;
  giorniPreavviso: number[];
  dataNotifica: string;
  stato: StatoScadenza;
  titolo?: string;
  descrizione?: string;
  tags?: string[];
  allegati?: string[];
  assegnatoAId?: string;
  assegnatoA?: User;
  completataIl?: string;
  completataDaId?: string;
  completataDa?: User;
  numeroFattura?: string;
  note?: string;
  annullataIl?: string;
  motivoAnnullamento?: string;
  // Campi per gestione rinnovi
  dataScadenzaOriginale?: string;
  giorniRitardoRinnovo?: number;
  scadenzaPadreId?: string;
  storicoRinnovi?: StoricoRinnovo[];
  createdAt: string;
  updatedAt: string;
}

export interface CreateScadenzaDto {
  clienteId: string;
  tipologiaId: string;
  dataScadenza: string;
  giorniPreavviso?: number[];
  titolo?: string;
  descrizione?: string;
  tags?: string[];
  assegnatoAId?: string;
  numeroFattura?: string;
}

export interface UpdateScadenzaDto {
  dataScadenza?: string;
  giorniPreavviso?: number[];
  titolo?: string;
  descrizione?: string;
  tags?: string[];
  assegnatoAId?: string;
  numeroFattura?: string;
}

export interface ScadenzaFilters {
  stato?: StatoScadenza;
  tipologiaId?: string;
  clienteId?: string;
  assegnatoAId?: string;
  dataScadenzaFrom?: string;
  dataScadenzaTo?: string;
  search?: string;
  tags?: string[];
}

export interface ScadenzaStats {
  totale: {
    attiva: number;
    in_scadenza: number;
    scaduta: number;
    completata: number;
    annullata: number;
  };
  inScadenza: {
    prossimi7Giorni: number;
    prossimi15Giorni: number;
    prossimi30Giorni: number;
  };
  scadute: number;
  distribuzionePerTipologia: Array<{
    _id: string;
    count: number;
    nome: string;
    categoria?: string;
  }>;
  distribuzionePerCliente: Array<{
    _id: string;
    count: number;
    nome: string;
    cognome: string;
    codiceFiscale?: string;
  }>;
}

export interface MonthNavigationProps {
  currentMonth: number;
  currentYear: number;
  onMonthChange: (month: number, year: number) => void;
}

export interface ScadenzeMensiliResponse {
  scadenze: Scadenza[];
  mese: number;
  anno: number;
  totalCount: number;
}

// Interfacce per gestione rinnovi
export interface StoricoRinnovo {
  dataScadenzaPrecedente: string;
  dataRinnovo: string;
  giorniRitardo: number;
  rinnovatoDaUserId: string;
  numeroFattura?: string;
  note?: string;
  scadenzaRinnovataId: string;
}

export interface CompletaScadenzaDto {
  numeroFattura?: string;
  noteRinnovo?: string;
  nuovaDataScadenza?: string;
}

export interface StoricoRinnoviResponse {
  scadenzaOriginale: {
    id: string;
    dataScadenzaOriginale: string;
    titolo: string;
  };
  storicoRinnovi: StoricoRinnovo[];
  scadenzeRinnovate: Scadenza[];
  totaleRinnovi: number;
}
